import { render, staticRenderFns } from "./Notifychange.vue?vue&type=template&id=16b766d5&scoped=true"
import script from "./Notifychange.vue?vue&type=script&lang=js"
export * from "./Notifychange.vue?vue&type=script&lang=js"
import style0 from "./Notifychange.vue?vue&type=style&index=0&id=16b766d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b766d5",
  null
  
)

export default component.exports